<template>
    <div>
      <h1>Depositing to WSB</h1>
      <button class="btn-back" @click="backmenu">
      <img src="/icons/back.png" alt="Back" class="arrow-icon" />
      Back to Deposit Menu
      </button>
      <p>
        User: <a>{{ username }}</a>
      </p>
  
      <!-- Mostrar el contenedor solo si no se ha enviado el depósito -->
      <div v-if="showDepositForm" class="contenedor">
        <!-- Mostrar el mensaje de éxito o error en la pantalla -->
      <div v-if="responseMessage" class="response-message" :class="responseType">
        <p v-html="responseMessage"></p>
      </div>
       
      </div>
  
      
  
      <div class="finaltext">
        <p>
        Your deposit should be on your account in a few seconds.
        If your deposit doesn't appear in your WSB balance in 5 seconds,<br>
        please <a href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us to let us know.
      </p>
      </div>
    </div>
  
   
  </template>

<script>

export default {
  data() {
    return {
      transactionData: {},
      username: this.$route.query.username || "Unknown User", // Obtener el parámetro de la URL
      amount: null,
      showError: false,
      responseMessage: "",  // Mensaje de la respuesta
      responseType: "",     // Tipo de mensaje (exito / error)
      showDepositForm: true, // Controla la visibilidad del formulario de depósito
      isLoading: false,      // Controla si la solicitud está en proceso
      amounts: [50, 100, 200, 300, 500, 700, 1000, 1500, 2000, 3000, 5000, 10000, 20000, 50000, 100000, 150000, 200000, 250000, 300000, 500000]
    };
  },
  methods: {
     backmenu() {
      this.$router.push({ name: 'DepositWebsiteLesotho' , query: { username: this.$route.query.username }  });
    },
    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },
    sendHeight() {
        const height = document.body.scrollHeight;
        window.parent.postMessage({ iframeHeight: height }, "*");
      }
},

  updated() {
    // Enviar altura después de que el DOM se actualice (por si hay cambios dinámicos)
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    // Limpiar el listener si lo agregaste
    window.removeEventListener("resize", this.sendHeight);
  },
  mounted() {
        // Enviar altura inicial al cargarse el componente
    this.sendHeight();

    // También puedes agregar un listener para resize si lo deseas
    window.addEventListener("resize", this.sendHeight);

      // Verifica si los datos son una cadena y conviértelos a un objeto
      
    this.transactionData = {
      Lite_Result_Description: this.$route.query.result_description,
      Lite_Payment_Card_Status: this.$route.query.payment_card_status,
      MerchantReference: this.$route.query.merchantReference
    };
    //console.log("Datos de la transacción:", this.transactionData);

    if (typeof this.transactionData === "string") {
        try {
        this.transactionData = JSON.parse(this.transactionData);
        } catch (error) {
        console.error("Error al parsear transactionData:", error);
        this.transactionData = {};
        }
    }
    console.log("Datos recibidos:", this.transactionData);
    if (this.transactionData) {
    if (this.transactionData.Lite_Result_Description=="Transaction cancelled by customer"){
        this.responseMessage = "<h2>Transaction Cancelled</h2> Reference: " + this.transactionData.MerchantReference;
    }else{ 
        this.responseMessage = "<h2>" + ((this.transactionData.Lite_Payment_Card_Status == 0) ? "Transaction completed successfully" : "Transaction Failed. Please try again later") + "</h2> Reference: " + this.transactionData.MerchantReference;
      }
        this.responseType = (this.transactionData.Lite_Payment_Card_Status == 0) ? "success" : "error";
    } else {
      this.responseMessage = "No transaction data available.";
      this.responseType = "error";
    }
    window.parent.postMessage({ action: 'payment_finalised' }, '*');
  }
}

</script>

<style scoped>
.arrow-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 8px;
}
.btn-back {
  background-color: #f99f44;        /* Naranja suave */
  color: rgb(0, 0, 0);
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  /* font-weight: bold; */
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}

.btn-back:hover {
  background-color: #f67d3c;        /* Naranja más fuerte en hover */
}

.finaltext {
  padding-left: 10px;
  padding-right: 10px;
  display: block;
}
/* Estilo para los mensajes de respuesta */
.response-message {
  margin-top: 20px;
  padding: 10px;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
}

.response-message.success {
  background-color: #d4edda;
  color: #155724;
}

.response-message.error {
  background-color: #f8d7da;
  color: #721c24;
}

h1 {
    color: #000;
    text-align: center;
    font-weight: 800;
    /* background-color: #f80; */
    padding: 15px;
}

</style>